import React from "react";

export default function ProgressBar({ progress, loading }) {
  if (!loading) return null;

  return (
    <div
      style={{
        display:"inline-block",
        width: "300px",
        // width: "100%",
        // marginTop: 20,
        marginRight: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 6,
          fontSize: 14,
        }}
      >
        <span>Downloading...</span>
        <span>{progress}%</span>
      </div>

      <div
        style={{
          width: "100%",
          height: 10,
          background: "#ddd",
          borderRadius: 20,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: "100%",
            background: "#4caf50",
            transition: "width .3s ease",
          }}
        />
      </div>
    </div>
  );
}